export const setKpiData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({type:"Set_Kpi_data", payload})
    } catch (error) {
      console.log(error)
    }
  };
};
export const setCompareData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({type:"Set_compare_data", payload})
    } catch (error) {
      console.log(error)
    }
  };
};
export const setAllTrendData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({type:"Set_alltrend_data", payload})
    } catch (error) {
      console.log(error)
    }
  };
};
export const setByPeriods = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({type:"Set_byperiod_data", payload})
    } catch (error) {
      console.log(error)
    }
  };
};



export const setGraphModel = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({type:"Set_graph_model", payload})
    } catch (error) {
      console.log(error)
    }
  };
};
export const setGraphObj = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({type:"Set_graph_obj", payload})
    } catch (error) {
      console.log(error)
    }
  };
};


///Hourly
export const setKpiDataHourly = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({type:"Set_Kpi_data_Hourly", payload})
    } catch (error) {
      console.log(error)
    }
  };
};
export const setCompareDataHourly = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({type:"Set_compare_data_Hourly", payload})
    } catch (error) {
      console.log(error)
    }
  };
};
export const setAllTrendDataHourly = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({type:"Set_alltrend_data_Hourly", payload})
    } catch (error) {
      console.log(error)
    }
  };
};
export const setByPeriodsHourly = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({type:"Set_byperiod_data_Hourly", payload})
    } catch (error) {
      console.log(error)
    }
  };
};